import { validateTexFormula } from '../shared/mathHealth';

type MarkdownNode = {
  type?: string;
  value?: string;
  lang?: string | null;
  data?: Record<string, unknown>;
  children?: MarkdownNode[];
};

/**
 * Validate math nodes after remark-math has parsed them. Invalid math is changed
 * into code before rehype-katex runs, so one broken formula cannot poison the
 * whole Markdown tree or produce a red KaTeX error node.
 */
export default function remarkMathHealth() {
  return (tree: MarkdownNode) => visit(tree);
}

function visit(node: MarkdownNode): void {
  if ((node.type === 'math' || node.type === 'inlineMath') && typeof node.value === 'string') {
    const displayMode = node.type === 'math';
    const result = validateTexFormula(node.value, displayMode);
    if (!result.ok) {
      node.type = displayMode ? 'code' : 'inlineCode';
      node.value = displayMode ? node.value : `$${node.value}$`;
      if (displayMode) node.lang = 'tex-invalid';
      delete node.data;
    }
  }
  for (const child of node.children || []) visit(child);
}
